// Libraries
import { color } from 'd3-color'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { interpolateRgb } from 'd3-interpolate'
import LiquidFillGauge from 'react-liquid-gauge'

// Styles
import './Gauge.less'

class Gauge extends Component {
  static propTypes = {
    // Valeur Ã  afficher
    value: PropTypes.number,

    // Couleurs
    startColor: PropTypes.string,
    endColor: PropTypes.string,

    // Rayon
    radius: PropTypes.number
  }

  static defaultProps = {
    // Valeur Ã  afficher
    value: 0,

    // Couleurs
    startColor: process.env.REACT_APP_MAIN_COLOR,
    endColor: process.env.REACT_APP_MAIN_COLOR,

    // Rayon
    radius: 200
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    const { startColor, endColor, value, radius } = this.props

    const interpolate = interpolateRgb(startColor, endColor)
    const fillColor = interpolate(value / 100)
    const gradientStops = [
      {
        key: '0%',
        stopColor: color(fillColor)
          .darker(0.5)
          .toString(),
        stopOpacity: 1,
        offset: '0%'
      },
      {
        key: '50%',
        stopColor: fillColor,
        stopOpacity: 0.75,
        offset: '50%'
      },
      {
        key: '100%',
        stopColor: color(fillColor)
          .brighter(0.5)
          .toString(),
        stopOpacity: 0.5,
        offset: '100%'
      }
    ]

    return (
      <LiquidFillGauge
        style={{ margin: '0 auto' }}
        width={radius * 2}
        height={radius * 2}
        value={value}
        percent='%'
        textSize={1}
        textOffsetX={0}
        textOffsetY={0}
        textRenderer={props => {
          const value = Math.round(props.value)
          const radius = Math.min(props.height / 2, props.width / 2)
          const textPixels = (props.textSize * radius) / 2
          const valueStyle = {
            fontSize: textPixels
          }
          const percentStyle = {
            fontSize: textPixels * 0.6
          }

          return (
            <tspan>
              <tspan className='value' style={valueStyle}>
                {value}
              </tspan>
              <tspan style={percentStyle}>{props.percent}</tspan>
            </tspan>
          )
        }}
        riseAnimation
        waveAnimation
        waveFrequency={2}
        waveAmplitude={1}
        gradient
        gradientStops={gradientStops}
        circleStyle={{
          fill: fillColor
        }}
        waveStyle={{
          fill: fillColor
        }}
        textStyle={{
          fill: color('#444').toString(),
          fontFamily: 'Arial'
        }}
        waveTextStyle={{
          fill: color('#fff').toString(),
          fontFamily: 'Arial'
        }}
      />
    )
  }
}

export default Gauge
